import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    component: () => import('../MainLayout.vue'),
    redirect: '/firstFraft',
    children: [{
        path: '/test1',
        name: 'test1',
        component: () => import('../views/Test1View.vue')
      },
      {
        path: '/test2',
        name: 'test2',
        component: () => import('../views/Test2View.vue')
      },
      {
        path: '/firstFraft',
        name: 'firstFraft',
        component: () => import('../views/FirstDraftView.vue')
      },
      {
        path: '/paperPrepare',
        name: 'paperPrepare',
        component: () => import('../views/PaperPrepareView.vue')
      },
      {
        path: '/optimize',
        name: 'optimize',
        component: () => import('../views/OptimizeView.vue')
      },
      {
        path: '/documentSearch/:id?',
        name: 'documentSearch',
        component: () => import('../views/DocumentSearchView.vue')
      },
      {
        path: '/mindMapping',
        name: 'mindMapping',
        component: () => import('../views/MindMappingView.vue')
      },
      {
        path: '/AIDetect',
        name: 'AIDetect',
        component: () => import('../views/AIDetectView.vue')
      },
      {
        path: '/upload',
        name: 'upload',
        component: () => import('../views/UploadView.vue')
      },
      {
        path: '/download',
        name: 'download',
        component: () => import('../views/DownloadView.vue')
      },
      {
        path: '/form',
        name: 'form',
        component: () => import('../views/FormView.vue')
      },
      {
        path: '/balance',
        name: 'balance',
        component: () => import('../views/BalanceView.vue')
      },
      {
        path: '/recharge',
        name: 'recharge',
        component: () => import('../views/RechargeView.vue')
      },
      {
        path: '/share',
        name: 'share',
        component: () => import('../views/ShareView.vue')
      },
      {
        path: '/zida-master',
        name: 'ZidaMaster',
        component: () => import('../views/ZidaMaster.vue')
      },
      {
        path: '/system/recharge',
        name: 'SystemRecharge',
        component: () => import('../views/SystemRechargeView.vue'),
        meta: { 
          title: '用户充值管理',
          requiresSystemRole: true
        }
      },
    ]
  },



  // {
  //   path: '/test1',
  //   name: 'test1',
  //   component: () => import('../views/Test1View.vue')
  // },
  // {
  //   path: '/test2',
  //   name: 'test2',
  //   component: () => import('../views/Test2View.vue')
  // },
  // {
  //   path: '/firstFraft',
  //   name: 'firstFraft',
  //   component: () => import('../views/FirstDraftView.vue')
  // },
  // {
  //   path: '/paperPrepare',
  //   name: 'paperPrepare',
  //   component: () => import('../views/PaperPrepareView.vue')
  // },
  // {
  //   path: '/optimize',
  //   name: 'optimize',
  //   component: () => import('../views/OptimizeView.vue')
  // },
  // {
  //   path: '/formulaFormatting',
  //   name: 'formulaFormatting',
  //   component: () => import('../views/PayHomeView.vue')
  // },
  // {
  //   path: '/documentSearch',
  //   name: 'documentSearch',
  //   component: () => import('../views/DocumentSearchView.vue')
  // },
  // {
  //   path: '/mindMapping',
  //   name: 'mindMapping',
  //   component: () => import('../views/MindMappingView.vue')
  // },
  // {
  //   path: '/AIDetect',
  //   name: 'AIDetect',
  //   component: () => import('../views/AIDetectView.vue')
  // },
  // {
  //   path: '/upload',
  //   name: 'upload',
  //   component: () => import('../views/UploadView.vue')
  // }
]

const router = new VueRouter({
  routes
})


router.beforeEach((to, from, next) => { //beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = `${Vue.prototype.$config.appName}-SCI级论文助手`
  }

  // 检查是否需要system角色权限
  if (to.meta && to.meta.requiresSystemRole) {
    const userInfo = store.getters.getUserInfo
    if (!userInfo || userInfo.userRole !== 'system') {
      // 用户未登录或不是system角色，跳转到首页
      Vue.prototype.$message.error('您没有权限访问此页面，需要系统管理员权限')
      next('/')
      return
    }
  }

  next()
})


export default router
